// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1793774729125
      var cssReload = require("/home/user/upos-dev/app/node_modules/@umijs/bundler-webpack/bundled/css/hotModuleReplacement.js")(module.id, {"publicPath":"./","hmr":true,"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  